export const ThemePrimary = {
  container: {
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '0 16px',
    fontFamily: 'Roboto',
    border: 'none',
    background: '#fff',
  },
  inputFocused: {
    outline: 'none',
  },
  inputOpen: {
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
  },
  suggestionsContainer: {
    display: 'none',
  },
  suggestionsContainerOpen: {
    display: 'block',
    position: 'absolute',
    top: 44,
    width: '100%',
    backgroundColor: '#fff',
    fontWeight: 400,
    fontSize: 14,
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
    zIndex: 2,
    // note: keep this boxShadow the same as @dropdown-box-shadow
    boxShadow: '0 2px 6px rgba(0,0,0,.05), 0 0 0 1px rgba(0,0,0,.07)',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  suggestion: {
    cursor: 'pointer',
    paddingLeft: '14px',
    paddingRight: '14px',
  },
  suggestionHighlighted: {
    backgroundColor: '#e7e7e7',
  },
}
export const ThemeSecondary = {
  ...ThemePrimary,
  input: {
    ...ThemePrimary.input,
    border: '1px solid rgba(46, 186, 211, 0.15)',
    borderRarius: '2px',
    padding: '0 30px',
  },
}
